
// AI Prayer Assistant constants
export const AI_PRAYER_ASSISTANT_SETTINGS_KEY = 'ai-prayer-assistant-settings';
export const AI_PRAYER_ASSISTANT_SETTINGS_UPDATED = 'ai-prayer-assistant-settings-updated';

// Form settings constants
export const FORM_SETTINGS_KEY = 'ai-prayer-form-settings';
export const FORM_SETTINGS_UPDATED = 'ai-prayer-form-settings-updated';

// Prayer content constants
export const PRAYER_CONTENT_STORAGE_KEY = 'morning-glory-generated-content';
export const PRAYER_CONTENT_UPDATED_EVENT = 'prayer-content-updated';

// HolyGround Hero constants
export const HOLYGROUND_HERO_STORAGE_KEY = 'holyground-hero-content';
export const HOLYGROUND_HERO_CARD_KEY = (index: number) => `holyground-hero-card-${index}`;
export const HOLYGROUND_HERO_UPDATED_EVENT = 'holyground-hero-updated';

// Prayer Hero constants
export const PRAYER_HERO_IMAGE_KEY = 'prayer-hero-image';
export const PRAYER_HERO_UPDATED_EVENT = 'prayer-hero-image-updated';

// Morning Glory component constants
export const MORNING_GLORY_STORAGE_KEY = 'morning-glory-content';
export const MORNING_GLORY_UPDATED_EVENT = 'morning-glory-content-updated';
export const MORNING_GLORY_MINIMIZED_KEY = 'morning-glory-minimized';
export const MORNING_GLORY_LIKES_KEY = 'morning-glory-likes';
export const MORNING_GLORY_LIKED_KEY = 'morning-glory-user-liked';

// Logo constants
export const LOGO_STORAGE_KEY = 'app-logo';
export const LOGO_UPDATED_EVENT = 'app-logo-updated';
